export const SelectConstants = {
    maxHeight: 194,
    minHeight: 100,
    resizeTimeoutMs: 50,
    searchKeydownTimeoutMs: 200,
    dropdownGap: 10,
    emptySearchMessage: 'Nothing was found',
    bordersHeight: 2
};
